<template>
<div class="file-share-avatar-content" ref="content">
    <div class="file-avatar-img">
      <div v-if="type === 'PERSON' && fileAvatar === ''" class="user-avatar" :style="avatarColorStye">
        <div class="user-name">{{ userName }}</div>
      </div>
      <img v-else :src="fileAvatar" />
    </div>
    <div class="file-avatar-name">{{ name }}</div>
  </div>
</template>

<script>
import { getNameColor, getLastName } from '@/utils/color';
import { getMemberAvatar } from '@/utils/avatar';

export default {
  name: 'FileShareAvatar',
  props: {
    avatar: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String
    }
  },
  data() {
    return {};
  },
  computed: {
    fileAvatar() {
      if (this.type === 'PERSON') {
        const userAvatar = getMemberAvatar(this.avatar, '');
        return userAvatar['100'] ?? userAvatar['300'] ?? userAvatar['original'];
      } else {
        return require('@/assets/h5/file/icon_file_file.png');
      }
    },
    avatarColorStye() {
      if (!this.name) {
        return 'background-color: #5C70FF;';
      }
      let avatarColor = getNameColor(this.name);
      return `background-color: ${avatarColor}`;
    },
    userName() {
      if (!this.name) {
        return '';
      }
      return getLastName(this.name);
    }
  },
  mounted() { },
  methods: {}
};
</script>

<style lang="scss" scope="true">
.file-share-avatar-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: #f4f6f9;
  border-radius: 8px;

  .file-avatar-img {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    margin-left: 4px;
    margin-right: 8px;

    img {
      width: 32px;
      height: 32px;
      border-radius: 8px;
    }

    .user-avatar {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      .user-name {
        font-family: PingFangSC-Regular;
        font-weight: 300;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 17px;
      }
    }
  }

  .file-avatar-name {
    font-family: PingFangSC-Regular;
    font-weight: 300;
    font-size: 14px;
    color: #323233;
    letter-spacing: 0;
    margin-right: 8px;
    white-space: nowrap;
  }
}
</style>
